import React, {createContext, useReducer} from "react";
import { TranslationReducer } from '../reducer/TranslationReducer';

export const TranslationContext = createContext();

export const initialTranslationState = {};

export const TranslationContextProvider = (props) => {
    
    const [translations, dispatch] = useReducer(TranslationReducer, initialTranslationState);
    return (
        <TranslationContext.Provider value = {{translations, translationDispatch: dispatch}} >
            {props.children}
        </TranslationContext.Provider>
    )
} 



// WEBPACK FOOTER //
// ./src/commons/context/TranslationContext.js